export default {
  "Aucun document.": "No documents.",
  "Projets": "Projects",
  "Aucun projet.": "No projects.",
  "Tâches ouvertes": "Open tasks",
  "Aucune.": "None.",
  "Rendez-vous": "Appointments",
  "Aucun rendez-vous lié.": "No linked appointments.",
  "Modifier la fiche": "Edit details",
  "Compte rendu de réunion": "Meeting minutes",
  "Nouveau document": "New document",
  "Modifier le client": "Edit customer",
  "Nouveau client": "New customer",
  "Nom du contact": "Contact name",
  "Société": "Company",
  "Téléphone": "Phone",
  "SIRET": "Company number (SIRET)",
  "N° TVA": "VAT number",
  "Adresse": "Address",
  "Aucun client": "No customers",
  "Ajoutez vos clients pour les associer aux transactions, devis, factures et projets.": "Add your customers to link them to transactions, quotes, invoices and projects.",
  "Modifier {0}": "Edit {0}",
  "Fichier vide ou illisible.": "Empty or unreadable file.",
  "{0} transaction(s) importée(s).": "{0} transaction(s) imported.",
  "Colonne {0}": "Column {0}",
  "Importer un relevé (CSV)": "Import a statement (CSV)",
  "Rien n'est enregistré avant votre validation. Les doublons probables sont signalés, jamais supprimés.": "Nothing is saved before you approve. Likely duplicates are flagged, never deleted.",
  "Choisissez un fichier CSV exporté depuis votre banque ou votre tableur": "Choose a CSV file exported from your bank or spreadsheet",
  "La première ligne contient les en-têtes": "The first row contains headers",
  "Libellé": "Label",
  "Montant (ou crédit)": "Amount (or credit)",
  "Débit (facultatif)": "Debit (optional)",
  "ligne(s). Montants négatifs = dépenses. Formats acceptés : 1 234,56 / -45.10 ; dates JJ/MM/AAAA ou AAAA-MM-JJ.": "row(s). Negative amounts = expenses. Accepted formats: 1 234,56 / -45.10; dates DD/MM/YYYY or YYYY-MM-DD.",
  "Changer de fichier": "Change file",
  "Analyser": "Analyse",
  "ligne(s) valide(s) ·": "valid row(s) ·",
  "Doublon probable": "Likely duplicate",
  "de « {0} » ({1})": "of “{0}” ({1})",
  "de la ligne {0} du fichier": "of row {0} in the file",
  "Ligne": "Row",
  "Retour": "Back",
  "Importer": "Import",
  "Hausse de tarif": "Price increase",
  "Baisse des dépenses": "Lower expenses",
  "Recrutement": "Hiring",
  "Achat d'équipement": "Equipment purchase",
  "Retard de paiement": "Late payment",
  "Hausse de tarif de {0} % dès le {1}": "{0}% price increase from {1}",
  "Dépenses courantes −{0} % dès le {1}": "Running expenses −{0}% from {1}",
  "Recrutement : {0}/mois dès le {1}": "Hiring: {0}/month from {1}",
  "Achat : {0} le {1}": "Purchase: {0} on {1}",
  "Nouveau client : +{0}/mois dès le {1}": "New customer: +{0}/month from {1}",
  "Factures payées avec {0} jours de retard": "Invoices paid {0} days late",
  "Optimiste": "Optimistic",
  "Central": "Base case",
  "Prudent": "Cautious",
  "30 jours": "30 days",
  "60 jours": "60 days",
  "90 jours": "90 days",
  "— solde à": "— balance at",
  "Point bas :": "Low point:",
  "Négatif dès le": "Negative from",
  "Solde de trésorerie projeté": "Projected cash balance",
  "Solde projeté sur {0} jours selon trois scénarios": "Projected balance over {0} days in three scenarios",
  "Simulateur de décisions": "Decision simulator",
  "Ajoutez des hypothèses pour voir leur effet estimé sur votre trésorerie. Rien n'est enregistré.": "Add assumptions to see their estimated effect on your cash flow. Nothing is saved.",
  "Type d'hypothèse": "Assumption type",
  "Valeur": "Value",
  "À partir du": "From",
  "Ajouter": "Add",
  "Retirer l'hypothèse": "Remove assumption",
  "Hypothèses et limites": "Assumptions and limits",
  "Réglée": "Settled",
  "En attente": "Pending",
  "Prévue": "Planned",
  "% vs période précédente": "% vs previous period",
  "Ce mois": "This month",
  "Cette année": "This year",
  "Commencez par vos données": "Start with your data",
  "Renseignez votre solde initial (Paramètres › Entreprise), ajoutez des transactions ou importez un relevé CSV. Aucune donnée n'est inventée.": "Enter your opening balance (Settings › Business), add transactions or import a CSV statement. No data is made up.",
  "Solde calculé": "Calculated balance",
  "Recettes": "Income",
  "Dépenses": "Expenses",
  "Résultat de la période": "Net result for the period",
  "Détecteur de risques": "Risk detector",
  "Évolution mensuelle (12 mois)": "Monthly trend (12 months)",
  "Recettes et dépenses par mois sur 12 mois": "Income and expenses per month over 12 months",
  "Dépenses par catégorie": "Expenses by category",
  "Aucune dépense sur la période.": "No expenses for this period.",
  "Transactions récurrentes": "Recurring transactions",
  "Aucune. Marquez un loyer ou un abonnement comme récurrent pour l'intégrer au prévisionnel.": "None. Mark rent or a subscription as recurring to include it in the forecast.",
  "Échéances à venir": "Upcoming payments",
  "Aucune transaction prévue ou en attente.": "No planned or pending transactions.",
  "Voir les factures à encaisser": "See invoices to collect",
  "Rechercher une transaction": "Search a transaction",
  "Tous types": "All types",
  "Toutes catégories": "All categories",
  "Tous statuts": "All statuses",
  "Du": "From",
  "Au": "To",
  "Importer CSV": "Import CSV",
  "doublon(s) probable(s) détecté(s) :": "likely duplicate(s) detected:",
  ". Vérifiez-les : rien n'est supprimé automatiquement.": ". Check them: nothing is deleted automatically.",
  "Supprimer {0} transaction(s) ?": "Delete {0} transaction(s)?",
  "Supprimer la sélection (": "Delete selection (",
  "Aucune transaction": "No transactions",
  "Ajoutez une transaction ou importez un relevé bancaire au format CSV.": "Add a transaction or import a bank statement in CSV format.",
  "Tout sélectionner": "Select all",
  "Montant": "Amount",
  "Sélectionner {0}": "Select {0}",
  "Suivi de gestion à partir de vos données : recettes, dépenses, trésorerie et prévisionnel. Ne remplace pas une comptabilité réglementée ni un conseil financier.": "Management tracking from your data: income, expenses, cash flow and forecast. Not a substitute for regulated accounting or financial advice.",
  "Prévisionnel & simulateur": "Forecast & simulator",
  "Clients": "Customers",
  "Libellé requis.": "Label required.",
  "Montant invalide (saisissez un montant positif).": "Invalid amount (enter a positive amount).",
  "Modifier la transaction": "Edit transaction",
  "Nouvelle transaction": "New transaction",
  "Dépense": "Expense",
  "Recette": "Income",
  "Montant (€)": "Amount (€)",
  "Encaissée": "Received",
  "Moyen de paiement": "Payment method",
  "Virement": "Bank transfer",
  "Carte": "Card",
  "Prélèvement": "Direct debit",
  "Espèces": "Cash",
  "Chèque": "Cheque",
  "Récurrence": "Recurrence",
  "Utilisée par le prévisionnel": "Used by the forecast",
  "Ponctuelle": "One-off",
  "Mensuelle": "Monthly",
  "Trimestrielle": "Quarterly",
  "Annuelle": "Yearly",
  "Jusqu'au (facultatif)": "Until (optional)",
  "Supprimer cette transaction ?": "Delete this transaction?",
  "Supprimer": "Delete",
  "Dans 1 h": "In 1 h",
  "Ce soir 18 h": "Tonight 6 pm",
  "Demain 9 h": "Tomorrow 9 am",
  "Lundi 9 h": "Monday 9 am",
  "Recevez vos rappels sur cet appareil, même application fermée.": "Get your reminders on this device, even when the app is closed.",
  "Notifications activées sur cet appareil.": "Notifications enabled on this device.",
  "Notifications refusées : autorisez-les dans les réglages du navigateur.": "Notifications blocked: allow them in your browser settings.",
  "Activer les notifications": "Enable notifications",
  "Marquer comme à faire": "Mark as to do",
  "Marquer comme fait": "Mark as done",
  "Reporter": "Snooze",
  "Supprimer le rappel": "Delete reminder",
  "Indiquez le texte et la date du rappel.": "Enter the reminder text and date.",
  "Rappel programmé.": "Reminder scheduled.",
  "Dites-le comme vous le pensez : « Rappelle-moi de relancer Paul jeudi à 10 h ». Votre Copilote s'occupe du reste.": "Say it the way you think it: “Remind me to follow up with Paul on Thursday at 10 am”. Your Copilot does the rest.",
  "Rappelle-moi de…": "Remind me to…",
  "Décrire le rappel": "Describe the reminder",
  "Créer": "Create",
  "Saisie manuelle": "Manual entry",
  "Relancer le devis Martin demain à 10 h": "Follow up on the Martin quote tomorrow at 10 am",
  "Tous les lundis à 9 h faire le point de la semaine": "Every Monday at 9 am review the week",
  "Payer l'URSSAF le 15 du mois": "Pay social charges on the 15th of the month",
  "Quand": "When",
  "M'envoyer aussi un e-mail": "Also send me an email",
  "Recevoir aussi un e-mail": "Also receive an email",
  "Recevez vos rappels par e-mail, même application fermée.": "Get your reminders by email, even when the app is closed.",
  "Programmer": "Schedule",
  "Aucun rappel": "No reminders",
  "Le Coach peut aussi en créer pour vous : demandez-lui « rappelle-moi de… ».": "The Coach can create them for you too: ask it “remind me to…”.",
  "Terminés (7 derniers jours)": "Done (last 7 days)",
  "{0} Ko": "{0} KB",
  "Poser une question à vos documents": "Ask your documents a question",
  "Recherche dans vos documents et fichiers texte, puis réponse avec citations. Seuls les éléments de votre espace sont consultés.": "Searches your documents and text files, then answers with citations. Only items in your workspace are used.",
  "Ex. Quelles décisions ont été prises lors des derniers comptes rendus ?": "E.g. What decisions were made in the latest meeting minutes?",
  "Question": "Question",
  "Rechercher et répondre": "Search and answer",
  "Recherche plein texte": "Full-text search",
  "Mots-clés, nom de client, projet…": "Keywords, customer name, project…",
  "Mots-clés": "Keywords",
  "Chercher": "Search",
  "Fichier": "File",
  "{0} : fichier trop volumineux (max {1}).": "{0}: file too large (max {1}).",
  "Échec du téléversement.": "Upload failed.",
  "{0} ajouté.": "{0} added.",
  "Stockage privé, base de connaissances et recherche documentaire avec citations.": "Private storage, knowledge base and document search with citations.",
  "Dossier": "Folder",
  "Téléverser": "Upload",
  "Fichiers": "Files",
  "Recherche & questions": "Search & questions",
  "Dossiers": "Folders",
  "Racine": "Root",
  "Rechercher par nom": "Search by name",
  "Rechercher un fichier": "Search a file",
  "Texte": "Text",
  "utilisés sur": "used of",
  "max par fichier · glissez-déposez vos fichiers ici": "max per file · drag and drop your files here",
  "Actions pour {0}": "Actions for {0}",
  "Nouveau nom": "New name",
  "Renommer": "Rename",
  "Supprimer ce dossier ? Son contenu remonte d'un niveau.": "Delete this folder? Its content moves up one level.",
  "Aucun fichier ici": "No files here",
  "Téléversez des PDF, images, documents texte ou Office. Les fichiers texte sont indexés pour la recherche et le coach.": "Upload PDFs, images, text or Office documents. Text files are indexed for search and the coach.",
  " · indexé": " · indexed",
  "Connaissances": "Knowledge",
  "Télécharger": "Download",
  "Retirer de la base de connaissances": "Remove from knowledge base",
  "Ajouter à la base de connaissances": "Add to knowledge base",
  "Lien temporaire (7 jours) copié.": "Temporary link (7 days) copied.",
  "Copier un lien temporaire": "Copy a temporary link",
  "Déplacer vers (nom du dossier, vide = racine) :\n{0}": "Move to (folder name, empty = root):\n{0}",
  "Déplacer…": "Move…",
  "Archiver": "Archive",
  "Supprimer définitivement « {0} » ?": "Permanently delete “{0}”?",
  "Nouveau dossier": "New folder",
  "Nom du dossier": "Folder name",
  "Aperçu indisponible.": "Preview unavailable.",
  "Pas d'aperçu pour ce type de fichier : téléchargez-le pour l'ouvrir.": "No preview for this file type: download it to open it.",
  "Réussie": "Succeeded",
  "Échec": "Failed",
  "À valider": "Awaiting approval",
  "est égal à": "equals",
  "est différent de": "is not",
  "Priorité de la tâche (1-5)": "Task priority (1-5)",
  "Titre de la tâche": "Task title",
  "Nom du projet": "Project name",
  "Type (quote, invoice, email…)": "Type (quote, invoice, email…)",
  "Montant TTC (centimes)": "Amount incl. tax (cents)",
  "Montant (centimes)": "Amount (cents)",
  "Nom du fichier": "File name",
  "Type de fichier": "File type",
  "Chaque jour": "Every day",
  "Chaque {0}": "Every {0}",
  "{0} ({1} € sur {2} j)": "{0} (€{1} over {2} d)",
  "Variables : {{task.title}}, {{document.title}}, {{project.name}}…": "Variables: {{task.title}}, {{document.title}}, {{project.name}}…",
  "Message (facultatif)": "Message (optional)",
  "Relancer {{project.name}}": "Follow up {{project.name}}",
  "Échéance (j)": "Due in (days)",
  "Objectif de l'e-mail": "Email goal",
  "Remercier le client et proposer un appel": "Thank the customer and suggest a call",
  "Cordial": "Friendly",
  "Ferme": "Firm",
  "Très courtois": "Very polite",
  "Automatisation créée.": "Automation created.",
  "Nouvelle automatisation": "New automation",
  "Quand… si… alors… Les actions sensibles demandent votre validation ; rien n'est envoyé à l'extérieur sans vous.": "When… if… then… Sensitive actions ask for your approval; nothing is sent outside without you.",
  "Ex. Tâche de suivi après chaque projet": "E.g. Follow-up task after each project",
  "Type de déclencheur": "Trigger type",
  "Événement": "Event",
  "Surveillance": "Watch",
  "Horaire": "Schedule",
  "Heure": "Time",
  "Surveiller": "Watch",
  "Horizon (j)": "Horizon (days)",
  "Seuil (€)": "Threshold (€)",
  "Les surveillances et horaires sont vérifiés toutes les 15 minutes ; chaque élément ne déclenche qu'une fois.": "Watches and schedules are checked every 15 minutes; each item triggers only once.",
  "Si (facultatif)": "If (optional)",
  "Champ": "Field",
  "Opérateur": "Operator",
  "Retirer la condition": "Remove condition",
  "Ajouter une condition": "Add a condition",
  "Alors": "Then",
  "Retirer l'action": "Remove action",
  "Demander ma validation avant d'agir (recommandé)": "Ask for my approval before acting (recommended)",
  "Ajouter une action": "Add an action",
  " · {0} tentatives": " · {0} attempts",
  "Simulation réussie : le scénario est valide. Aucune action exécutée.": "Test successful: the scenario is valid. No action was run.",
  "Conditions non remplies pour un événement vide.": "Conditions not met for an empty event.",
  "Exécution en échec : consultez le journal.": "Run failed: check the log.",
  "Exécutée.": "Run.",
  "Des scénarios « quand… si… alors… » qui travaillent pour vous. Les e-mails restent des brouillons et les créations sensibles attendent votre validation.": "“When… if… then…” scenarios that work for you. Emails stay as drafts and sensitive creations wait for your approval.",
  "Nouveau scénario": "New scenario",
  "Mes automatisations": "My automations",
  "Modèles": "Templates",
  "Journal": "Log",
  "Aucune automatisation": "No automations",
  "Commencez par un modèle prêt à l'emploi : rappel de facture, plan du lundi, brouillon d'e-mail de devis…": "Start with a ready-made template: invoice reminder, Monday plan, quote email draft…",
  "Voir les modèles": "See templates",
  " · si {0}": " · if {0}",
  "Désactiver": "Disable",
  " · à valider": " · needs approval",
  "Dernière exécution {0}": "Last run {0}",
  "Jamais exécutée": "Never run",
  "Tester": "Test",
  "Exécuter": "Run",
  "Supprimer {0}": "Delete {0}",
} as Record<string, string>;
